module.exports = __webpack_public_path__ + "static/media/prep-logo-white.62c5b7bc.svg";